import { observer } from 'mobx-react';
import { useRouteLoaderData } from 'react-router';

import { CampQuery, usePaymentsQuery, usePersonsStatisticsQuery } from '../../generated/graphql';
import { useEffect, useState } from 'react';
import { set } from 'mobx';
import { styled } from '@mui/material';

export const PaymentsDashboard = observer(function PaymentsDashboard() {
  const camp = useRouteLoaderData('camp') as CampQuery['camp'];

  const [payed, setPayed] = useState(0);
  const [total, setTotal] = useState(0);

  const PaymentData = usePaymentsQuery({
    variables: {
      camp_id: camp.camp_id,
    },
  });

  const { data, loading, error } = usePersonsStatisticsQuery({
    variables: {
      camp_id: camp.camp_id,
    },
    skip: !camp,
  });



  useEffect(() => {
    if (data && PaymentData.data && PaymentData.data.payments) {

      const { total, today, week } = data.personsStatistics;
      const payments = PaymentData.data.payments;
      const payedCount = payments.reduce((acc, payment) => {
        if (payment?.status === 5) {
          return acc + 1;
        }
        return acc;
      }, 0);
      setPayed(payedCount);
      setTotal(total);


    }
  }
  , [PaymentData.data, data]);


  return (
    <StatisticsDiv>
      <div>
        <div className="circle">
          <span>{payed}</span>
        </div>
        <span>Har betalt</span>
      </div>
      <div>
        <div className="circle">
          <span>{total - payed}</span>
        </div>
        <span>Har inte betalat</span>
      </div>
    </StatisticsDiv>
  );
});

export const StatisticsDiv = styled('div')`
  margin-top: 14px;
  display: flex;
  /* align-items: center; */

  text-align: center;
  font-size: 16px;
  font-weight: 700;
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50%;
    padding: 10px;
  }

  .circle {
    font-size: 18px;
    color: white;
    background: ${(p) => p.theme.palette.primary.main};
    position: relative;
    border-radius: 25px;
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
    > span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
